import { usePayer } from 'src/state/payer';
import { useProvider } from 'src/state/provider';
import { getDomain } from 'src/tools/getDomain';
import { usePayers } from '@sde/widgets-core/src/redux/resources/payers';
import React from 'react';

export const sections = [
  {
    id: 'eligibility-search',
    name: 'Eligibility & Benefits Search',
    icon: 'umbrella',
    component: () => {
      const { provider } = useProvider.state();
      const { payer } = usePayer.state();
      const { payers } = usePayers.state();
      const domain = getDomain('sde-eligibility', 3100);
      return (
        <abyss-parcel
          scriptdomain={domain}
          import="eligibility-new-eligbility-search@dev"
          provider={JSON.stringify(provider)}
          payer={JSON.stringify(payer)}
          payers={JSON.stringify(payers)}
        />
      );
    },
  },
  {
    id: 'claim-search',
    name: 'Claims Search',
    icon: 'cost',
    component: () => {
      const { provider } = useProvider.state();
      const { payer } = usePayer.state();
      const { payers } = usePayers.state();
      const domain = getDomain('sde-claims', 3200);
      return (
        <abyss-parcel
          scriptdomain={domain}
          import="claims-new-claims-search@dev"
          props={JSON.stringify({ isClaimTab: true, isNewClaimSearch: true })}
          provider={JSON.stringify(provider)}
          payer={JSON.stringify(payer)}
          payers={JSON.stringify(payers)}
        />
      );
    },
  },
  {
    id: 'referrals-search',
    name: 'Referral Search',
    icon: 'network',
    component: () => {
      const { provider } = useProvider.state();
      const { payer } = usePayer.state();
      const domain = getDomain('sde-referrals', 3300);
      return (
        <abyss-parcel
          scriptdomain={domain}
          import="referrals-referrals-search@dev"
          props={JSON.stringify({
            isReferralsTab: true,
            isNewReferralsSearch: true,
          })}
          provider={JSON.stringify(provider)}
          payer={JSON.stringify(payer)}
        />
      );
    },
  },
];
